"use strict";
import { CompanyMenu } from "components/NavBar/CompanyMenu";
import { PrimaryNav } from "components/NavBar/PrimaryNav";
import { PreferenceMenu } from "components/NavBar/PreferencesMenu";
import { SearchBar } from "components/NavBar/SearchBar";
import TestnetModeTooltip from "components/NavBar/TestnetMode/TestnetModeTooltip";
import Row from "components/deprecated/Row";
import Web3Status from "components/walletConnect";
import { useAccount } from "hooks/useAccount";
import deprecatedStyled, { css } from "lib/styled-components";
import { Flex, Nav as TamaguiNav, styled, useMedia } from "ui/src";
import { INTERFACE_NAV_HEIGHT, breakpoints, zIndexes } from "ui/src/theme";
import { useEnabledChains } from "features/chains/hooks/useEnabledChains";
const UnpositionedFlex = styled(Flex, {
  position: "unset"
});
const Nav = styled(TamaguiNav, {
  position: "unset",
  px: "$padding12",
  width: "100%",
  height: INTERFACE_NAV_HEIGHT,
  zIndex: zIndexes.sticky,
  justifyContent: "center"
});
const NavItems = css`
  gap: 12px;
  @media screen and (max-width: ${breakpoints.md}px) {
    gap: 4px;
  }
`;
const Left = deprecatedStyled(Row)`
  display: flex;
  align-items: center;
  wrap: nowrap;
  ${NavItems}
`;
const Right = deprecatedStyled(Row)`
  justify-content: flex-end;
  ${NavItems}
`;
export default function Navbar() {
  const media = useMedia();
  const isSmallScreen = media.md;
  const collapseSearchBar = media.xl;
  const account = useAccount();
  const NAV_SEARCH_MAX_HEIGHT = "calc(100vh - 30px)";
  const { isTestnetModeEnabled } = useEnabledChains();
  return <Nav>
      <UnpositionedFlex row centered width="100%">
        <Left>
          <CompanyMenu />
          <PrimaryNav />
        </Left>

        {!collapseSearchBar && <SearchBar maxHeight={NAV_SEARCH_MAX_HEIGHT} fullScreen={isSmallScreen} />}

        <Right>
          {collapseSearchBar && <SearchBar maxHeight={NAV_SEARCH_MAX_HEIGHT} fullScreen={isSmallScreen} />}

          {!account.isConnected && !account.isConnecting && <PreferenceMenu />}
          {isTestnetModeEnabled && <TestnetModeTooltip />}
          <Web3Status />
        </Right>
      </UnpositionedFlex>
    </Nav>;
}
